var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kendo-multiselect',{ref:'citationMultiSelect',attrs:{"data-source":_vm.formDataSource,"data-value-field":'FormIdentity',"data-text-field":'FormName',"placeholder":'No fields selected...'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }